import Vue from 'vue'
import App from './App.vue'
// 按需引入：仅打包实际用到的 ElementUI 组件 JS
import {
  Button,
  Table,
  TableColumn,
  TimePicker,
  // 管理端成就配置的「统计时段」用 el-time-select（可配置时段参数）
  TimeSelect,
  Slider,
  Radio,
  RadioGroup,
  RadioButton,
  DatePicker,
  Dialog,
  Input,
  Message,
  MessageBox,
  Notification,
  // ↓ 管理端用：Element UI 是按需引入，不注册就不会渲染，且不报错
  Form,
  FormItem,
  Select,
  Option,
  Pagination,
  Switch,
  Tag,
  Tabs,
  TabPane,
  Card,
  Row,
  Col,
  Tooltip,
  InputNumber,
  // 管理端表格操作列：用 el-link 承载「危险 / 警告」语义，而不是给 el-button--text
  // 挂自定义颜色类（Element UI 的 text 按钮没有 danger/warning 预设色，自定义就得在
  // 每个 panel 的 scoped 里各写一遍 —— 重复且不好维护）。
  Link,
  // v-loading 指令：项目里 NotificationPanel / ShareDialog / 管理端各表格都在用，
  // 但此前从未注册过（指令未解析 = 静默不生效）。这里补上。
  Loading
} from 'element-ui'
// 保留全量 CSS：el-icon-close / el-icon-check 等图标字体依赖这里面的 iconfont
import 'element-ui/lib/theme-chalk/index.css'
// 全屏浮层传送门：时间表全屏走原生 Fullscreen API，.tablebox 会进浏览器 top layer，
// 挂在 document.body 下的 Element 浮层（$message / $confirm / $alert / $notify）
// 无论 z-index 多高都会被全屏视图盖住。这里在原型方法上包一层「显示后搬进全屏元素」，
// 非全屏时是 no-op，普通页面行为零变化（原理见该文件顶部注释）。
import { portalSelectorToFullscreen, wrapFullscreenAware } from './utils/fullscreenPortal'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(TimePicker)
Vue.use(TimeSelect)
Vue.use(Slider)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Input)
Vue.prototype.$message = wrapFullscreenAware(Message)
// 右上角轻提示：评论发送成功/失败等结果反馈（统一封装见 @/utils/notify.js）
Vue.prototype.$notify = wrapFullscreenAware(Notification)
// $confirm / $alert：MessageBox 是 document.body 下的单例，调用时 wrapper 已同步挂上 body，
// 立刻搬进全屏元素；PopupManager 稍后插入的 .v-modal 会作为它的兄弟节点一起进来。
const portalConfirm = raw => function(message, title, options) {
  const p = raw(message, title, options)
  portalSelectorToFullscreen('.el-message-box__wrapper')
  return p
}
Vue.prototype.$confirm = portalConfirm(MessageBox.confirm)
Vue.prototype.$alert = portalConfirm(MessageBox.alert)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Switch)
Vue.use(Tag)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tooltip)
Vue.use(InputNumber)
Vue.use(Link)
Vue.use(Loading.directive)

new Vue({
  render: h => h(App),
}).$mount('#app')
